import React from 'react';
import ProgressLabel from '../progress-label';
import OrgImage from '../org-image';
import ContactData from '../contact-data';
import { Element, ContainerProgress } from './styles';

const Org = ({ item }) => (
  <Element id={`org-card-${item.id || 'unknown'}`}>
    <ContainerProgress id={`org-progress-${item.id || 'unknown'}`}>
      <ProgressLabel amount={item.compliance.maturity} />
    </ContainerProgress>
    <OrgImage src={item.imageUrl} id={`org-image-${item.id || 'unknown'}`} />
    <h1 id={`org-name-${item.id || 'unknown'}`}>{item.name}</h1>
    <small id={`org-responsible-${item.id || 'unknown'}`}>{item.responsible.name || '< Responsável não definido >'}</small>
    <div id={`org-contact-${item.id || 'unknown'}`}>
      {item.responsible.email && (
        <ContactData contact={item.responsible.email} />
      )}
    </div>
  </Element>
);

export default Org;